'use client';
import React, { useState } from 'react';
import { Button, Div, Drawer, Media } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import Link from 'next/link';
import DrawerMenu from '@layouts/header/sub-component/drawer/drawer-menu';
import { BasketButton, UserInfo } from '../desktop-header/desktop-header';
import routes from '@routes';
import PhoneWhiteIcon from '@icons-components/phone-white-icon';
import HamburgerIcon from '@icons-components/hamburger-icon';
import AddToBasketIcon from '@icons-components/add-to-basket-icon';
import process from 'process';
import CanadaFlagIcon from '@icons-components/canada-flag-icon';

export const headerLinks = [
  {
    slug: 'users',
    title: 'پزشکان',
    url: routes['route.users.index'],
    isActive: process.env.APPOINTMENT_SERVICE_ACTIVE === 'true' && process.env.CONSULT_SERVICE_ACTIVE === 'true',
  },
  {
    slug: 'pharmacies',
    title: 'داروخانه',
    url: routes['route.pharmacies.index'],
    isActive: process.env.PHARMACY_SERVICE_ACTIVE === 'true',
  },
  {
    slug: 'products',
    title: 'محصولات',
    url: routes['route.products.index'],
    isNew: true,
    isActive: process.env.PRODUCT_SERVICE_ACTIVE === 'true',
  },
  {
    slug: 'labs',
    title: 'آزمایش پزشکی در منزل',
    hasInsurance: true,
    url: routes['route.labs.index'],
    isActive: process.env.LABORATORY_SERVICE_ACTIVE === 'true',
  },
  {
    slug: 'home-care',
    title: 'خدمات پزشکی در منزل',
    url: routes['route.home-care.index'],
    isActive: process.env.HOME_CARE_SERVICE_ACTIVE === 'true',
  },
  {
    slug: 'posts',
    title: 'مجله سلامت',
    url: routes['route.posts.index'],
    isActive: true,
  },
  {
    slug: 'faq',
    title: 'سوال های متداول',
    url: '/faq',
    isActive: true,
  },
  {
    slug: 'about-us',
    title: 'درباره ما',
    url: '/about-us',
    isActive: true,
  },
  {
    slug: 'contacts',
    title: 'تماس با ما',
    url: '/contacts',
    isActive: true,
  },
  {
    slug: 'complaints',
    title: 'شکایات',
    url: '/client-dashboard/orders',
    isActive: true,
  },
];

const ResponsiveHeader = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenDrawer(newOpen);
  };

  const otpModalToggle = () => {
    setOpenDrawer(false);
  };

  return (
    <Div className={'w-full justify-between items-center h-16 bg-white px-4 rounded-lg shadow-lg'}>
      <Div className={'items-center gap-4'}>
        <Button
          className={'!p-0'}
          variant={'text'}
          startAdornment={<CanadaFlagIcon/>}
          href={'https://pbmeds.com'}
          size={'huge'}/>
        <Link passHref={true} href={'/'}>
          <Div className={'relative object-contain h-5 w-28 sm:h-6 sm:w-36'}>
            <Image sizes={'20vw'} src={'/images/header/logo.svg'} alt={'logo'}/>
          </Div>
        </Link>
      </Div>
      <Div className={'items-center gap-x-2'}>
        <Media greaterThan={'xs'}>
          <Div>
            <UserInfo isResponsive={true}/>
          </Div>
        </Media>
        <Button aria-label={'support-phone'} href={'tel://02191004191'} color={'secondary'} shape={'square'}>
          <Div className={'relative object-contain w-4 h-4'}>
            <PhoneWhiteIcon/>
          </Div>
        </Button>
        <BasketButton>
          <Button
            href={routes['route.basket.index']}
            shape={'square'}
            variant={'outlined'}
            startAdornment={<AddToBasketIcon/>}
          />
        </BasketButton>
        <Button aria-label={'ham-menu'} variant={'outlined'} size={'medium'} shape={'square'} onClick={toggleDrawer(true)}>
          <Div className={'relative object-contain w-4 h-4'}>
            <HamburgerIcon/>
          </Div>
        </Button>
      </Div>
      <Drawer
        className={'!py-0'}
        anchor={'start'}
        open={openDrawer}
        onClose={toggleDrawer(false)}>
        <DrawerMenu openDrawer={openDrawer} menuCallBack={otpModalToggle} items={headerLinks} onClick={toggleDrawer(false)}/>
      </Drawer>
    </Div>
  );
};

export default ResponsiveHeader;
